interface Props {
    isShow: boolean;
    isNoFree: boolean;
}

export default function InputFormatInfo({ isShow, isNoFree }: Props) {

    if(!isShow) return null;

    return (
        <div className="flex items-start gap-2 border-b border-blue-200 bg-[#eef6fc] px-3 py-2 text-[11px] text-[#185b91]">
            <svg className="mt-0.5 h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 11v5" />
                <path d="M12 8h.01" />
            </svg>
            <p>
                <span className="font-semibold">Allowed inputs:</span>{" "}
                <span className="font-medium">N/A</span>
                {!isNoFree && (
                    <>
                        , <span className="font-medium">FREE</span>
                    </>
                )}
                , or a numeric value with a maximum of{" "}
                <span className="font-medium">4 decimal places</span> (e.g. 1, 1.25, 1.2345).
            </p>
        </div>
    )
}
